var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 220,
    viewBox: "0 0 348 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M344.268 156.924C347.968 144.824 348.868 132.024 346.168 119.624C341.968 100.324 328.568 76.9243 289.668 66.8243C216.168 47.7243 190.568 -8.17573 121.768 9.62427C121.768 9.62427 84.8679 16.3243 67.3679 77.4243C49.8679 138.524 -18.5321 139.524 4.96793 192.724C8.86793 201.424 19.1679 210.924 34.0679 219.824L312.968 218.924C332.468 195.724 338.468 175.724 344.268 156.924Z",
    fill: "#EBEBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M278.468 113.224H267.968V101.824C267.968 96.1242 263.968 91.3242 258.568 90.0242V75.8242H254.668V89.7242C248.468 90.3242 243.668 95.4242 243.668 101.824V113.624H233.268V126.724H232.568V151.124L213.668 151.024V121.824H192.068V143.224H176.868V164.024H158.468V219.024H219.568H232.668H309.268V149.724H278.468V113.224Z",
    fill: "#D6D7F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4678 143.424V116.124H72.7678V101.524H76.5678V116.124H86.0678V143.424H96.6678V159.824H113.468V104.024H148.768V218.924H125.768H115.868H90.9678H79.4678H49.4678V143.424H62.4678Z",
    fill: "#D6D7F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M254.968 218.625L94.3682 218.725C88.2682 218.725 83.3682 213.825 83.3682 207.725L265.968 207.625C265.968 213.725 261.068 218.625 254.968 218.625Z",
    fill: "#56B7F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M254.968 214.825L94.3682 214.925C89.6682 214.925 85.5682 211.925 84.0682 207.725H83.3682C83.3682 213.825 88.2682 218.725 94.3682 218.725L254.968 218.625C261.068 218.625 265.968 213.725 265.968 207.625H265.268C263.768 211.825 259.768 214.825 254.968 214.825Z",
    fill: "#5571E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M185.068 211.325H164.368C162.368 211.325 160.668 209.725 160.668 207.625H188.768C188.768 209.725 187.068 211.325 185.068 211.325Z",
    fill: "#27429C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M256.568 207.624L92.768 207.724L92.668 108.824C92.668 103.124 97.268 98.5243 102.968 98.5243L246.268 98.4243C251.968 98.4243 256.568 103.024 256.568 108.724V207.624Z",
    fill: "#5571E9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M248.068 107.024H101.268V199.124H248.068V107.024Z",
    fill: "#312C76"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M248.068 190.324H101.268V199.124H248.068V190.324Z",
    fill: "#151247"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M248.068 107.024H101.268V111.424H248.068V107.024Z",
    fill: "#151247"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M150.168 107.124L101.268 156.024V199.224H101.468L193.368 107.024L150.168 107.124Z",
    fill: "#5571E9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M120.268 199.224L141.968 199.124L233.968 107.024H212.268L120.268 199.224Z",
    fill: "#5571E9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M230.768 199.125L248.068 181.825V149.125L196.268 199.125H230.768Z",
    fill: "#5571E9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M256.568 146.424H92.668V164.524H256.568V146.424Z",
    fill: "#F5D100"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113.168 170.824H99.0684L111.168 143.024H125.268L113.168 170.824Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M143.268 170.824H129.168L141.268 143.024H155.368L143.268 170.824Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M173.268 170.824H159.168L171.368 143.024H185.468L173.268 170.824Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M203.368 170.824H189.268L201.368 143.024H215.468L203.368 170.824Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M233.468 170.824H219.368L231.468 143.024H245.568L233.468 170.824Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5678 115.124L76.3678 115.224L74.4678 114.624C73.5678 114.324 72.6678 114.724 72.1678 115.424L71.9678 115.824L81.3678 121.024L83.1678 117.124L79.5678 115.124Z",
    fill: "#14103D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2682 121.124L71.8682 115.924L72.1682 115.324C72.2682 115.224 72.3682 115.124 72.4682 115.224L81.6682 120.324L81.2682 121.124Z",
    fill: "#14103D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0684 117.124L85.5684 112.824L83.0684 108.424L79.5684 115.124L83.0684 117.124Z",
    fill: "#EB8175"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M102.469 92.5242C102.469 92.5242 89.1685 88.7242 87.8685 92.3242C86.5685 95.9242 78.7686 111.824 78.7686 111.824L84.5685 114.824L93.2686 99.7242L104.969 98.7242L102.469 92.5242Z",
    fill: "#14103D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6684 120.024L89.0684 121.724L87.1684 122.124C86.2684 122.324 85.6684 123.024 85.5684 123.924V124.324H96.2684L95.9684 120.024H91.6684Z",
    fill: "#14103D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1682 124.324H85.3682V123.624C85.3682 123.524 85.4682 123.424 85.5682 123.424H96.0682L96.1682 124.324Z",
    fill: "#14103D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M95.868 120.024L96.168 112.824L91.968 112.324L91.668 120.024H95.868Z",
    fill: "#EB8175"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M104.268 91.9243L91.6679 92.5243C91.6679 92.5243 89.8679 92.6243 89.9679 96.8243C90.0679 101.024 90.0679 118.124 90.0679 118.124L96.0679 118.324L97.2679 100.424L109.868 100.224C112.568 100.224 114.968 98.6243 116.068 96.2243C116.468 95.3243 116.668 94.2243 116.368 93.1243L104.268 91.9243Z",
    fill: "#231C61"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3683 89.324C92.3683 90.524 91.5683 90.724 90.3683 90.724C89.1683 90.724 88.0684 90.524 88.0684 89.324C88.0684 88.124 89.0684 87.124 90.2684 87.124C91.3684 87.224 92.3683 88.124 92.3683 89.324Z",
    fill: "#E1AD9D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M93.868 90.524H91.368C90.668 90.524 90.168 90.024 90.168 89.324C90.168 88.624 90.668 88.124 91.368 88.124H93.868C94.568 88.124 95.068 88.624 95.068 89.324C95.068 90.024 94.568 90.524 93.868 90.524Z",
    fill: "#E1AD9D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7688 90.8242L92.9688 86.7242L103.269 85.6242L105.369 73.6242C105.569 72.5242 107.169 71.2242 108.269 71.4242L107.969 71.3242C109.069 71.5242 110.069 72.8242 109.869 73.9242L107.869 88.3242C107.769 89.1242 107.169 89.7242 106.369 89.9242L93.7688 90.8242Z",
    fill: "#C8C6F2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M114.269 71.624C114.469 71.624 114.669 71.724 114.869 71.724H114.969C116.769 72.424 117.969 74.324 117.969 76.124L116.369 93.124C105.769 93.024 104.169 91.824 104.169 91.824L104.969 74.424C105.069 72.824 105.869 71.224 107.769 71.124L114.269 71.624Z",
    fill: "#D8D7FD"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M102.568 90.7239C102.668 91.9239 101.868 92.1239 100.668 92.2239C99.4683 92.3239 98.3683 92.2239 98.2683 91.0239C98.1683 89.8239 99.0683 88.8239 100.268 88.7239C101.468 88.6239 102.468 89.5239 102.568 90.7239Z",
    fill: "#EB8175"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M104.168 91.8238L101.668 92.0238C100.968 92.0238 100.468 91.5238 100.368 90.9238C100.368 90.2238 100.868 89.7238 101.468 89.6238L103.968 89.4238C104.668 89.4238 105.168 89.9238 105.268 90.5238C105.368 91.2238 104.868 91.7238 104.168 91.8238Z",
    fill: "#EB8175"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M104.069 92.024L102.969 88.024L114.169 86.224L113.569 75.824C113.669 74.724 114.869 73.524 115.969 73.624C117.069 73.724 118.169 74.924 118.069 76.024L118.869 88.524C118.769 89.324 118.269 89.924 117.469 90.224L104.069 92.024Z",
    fill: "#D8D7FD"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7689 78.2241L96.9688 79.4241C97.3688 79.4241 97.6689 79.8241 97.7689 80.2241L99.0688 91.2241C99.1688 91.7241 98.6688 92.2241 98.1688 92.1241L85.7689 90.9241C85.3689 90.9241 85.0688 90.5241 84.9688 90.1241L83.8688 79.1241C83.7688 78.6241 84.1689 78.2241 84.7689 78.2241Z",
    fill: "#091218"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0686 78.124L96.2686 79.324C96.6686 79.324 96.9686 79.724 97.0686 80.124L98.3686 91.124C98.4686 91.624 97.9686 92.124 97.4686 92.024L85.0686 90.824C84.6686 90.824 84.3686 90.424 84.2686 90.024L83.1686 79.024C83.0686 78.524 83.4686 78.124 84.0686 78.124Z",
    fill: "#1B2934"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6684 91.2241L106.968 92.0241C107.268 92.0241 107.368 92.2241 107.368 92.5241C107.368 92.8241 107.168 92.9241 106.868 92.9241L98.0684 92.1241L98.6684 91.2241Z",
    fill: "#091218"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0684 84.8239C90.9684 85.5239 90.3684 86.1239 89.5684 86.0239C88.8684 85.9239 88.2684 85.3239 88.3684 84.5239C88.4684 83.8239 89.0684 83.2239 89.8684 83.3239C90.5684 83.4239 91.0684 84.1239 91.0684 84.8239Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M113.169 78.2241L113.469 86.0241L102.969 88.0241L112.169 85.1241L113.169 78.2241Z",
    fill: "#C8C6F2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M107.668 70.6242L108.368 72.5242C108.668 73.2242 109.268 73.6242 109.968 73.7242C111.368 73.8242 112.268 72.4242 111.768 71.2242L110.568 68.3242L107.668 70.6242Z",
    fill: "#EB8175"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M108.268 72.224C108.268 72.224 111.668 71.524 111.168 68.524C110.668 65.524 107.468 67.824 107.468 67.824L107.768 70.824L108.268 72.224Z",
    fill: "#E16C5F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M102.968 63.2244C101.668 65.9244 102.868 69.1244 105.568 70.4244C108.268 71.7244 111.469 70.5244 112.769 67.8244C114.069 65.1244 112.869 61.9244 110.169 60.6244C107.369 59.4244 104.168 60.5244 102.968 63.2244Z",
    fill: "#EB8175"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M109.868 66.6242C109.868 66.6242 109.068 70.9242 112.168 71.0242C115.368 71.1242 113.568 62.9242 113.568 62.9242L108.568 57.8242L100.868 59.7242L101.668 64.7242C101.668 64.7242 102.868 65.3242 109.468 64.3242L109.868 66.6242Z",
    fill: "#231C61"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M106.668 63.2241L109.168 66.9241L111.368 64.5241L106.668 63.2241Z",
    fill: "#231C61"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M108.968 65.6244C108.568 66.4244 108.968 67.3244 109.668 67.6244C110.468 68.0244 111.368 67.6245 111.668 66.9245C112.068 66.1245 111.668 65.2245 110.968 64.9245C110.268 64.5245 109.368 64.8244 108.968 65.6244Z",
    fill: "#EB8175"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M101.868 64.6242C101.868 64.6242 100.668 60.3242 103.468 57.7242C105.768 55.5242 109.468 55.7242 111.468 58.1242C112.368 59.2242 113.168 60.9242 113.268 63.5242L101.868 64.6242Z",
    fill: "#F5D100"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.658 60.4839H103.668C104.442 60.4839 104.996 61.0392 105.106 61.701L105.108 61.7079L105.107 61.7079L105.407 64.3079L105.129 64.3401L104.829 61.7436C104.739 61.2097 104.297 60.7688 103.678 60.7641C103.042 60.859 102.608 61.3071 102.608 61.924V64.624H102.328V61.924C102.328 61.144 102.89 60.5936 103.648 60.4853L103.658 60.4839Z",
    fill: "#F1AB00"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.826 63.4702C113.855 63.7782 113.63 64.0521 113.322 64.0819L100.922 65.2819C100.614 65.3117 100.34 65.0862 100.31 64.7782C100.28 64.4702 100.506 64.1963 100.814 64.1665L113.214 62.9665C113.522 62.9367 113.796 63.1622 113.826 63.4702Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M225.968 207.024L228.768 209.724L225.568 211.424L222.868 208.724L225.968 207.024Z",
    fill: "#EB8175"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M206.468 186.924L208.368 195.124C208.768 196.724 209.468 198.324 210.468 199.824L222.668 210.824L227.468 206.924L217.068 195.924L213.268 181.324L206.468 186.924Z",
    fill: "#14103D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M225.468 211.324L224.468 214.524L223.368 216.124C222.868 216.824 222.868 217.824 223.368 218.524L223.668 218.824L231.468 211.524L228.368 208.624L225.468 211.324Z",
    fill: "#14103D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M231.568 211.624L223.668 218.924L223.068 218.224L230.868 210.924L231.568 211.624Z",
    fill: "#14103D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M199.268 212.024L198.268 215.424L194.668 214.524L195.768 211.124L199.268 212.024Z",
    fill: "#EB8175"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M204.068 177.724L194.068 211.524L200.368 213.124L205.968 196.124L212.868 185.024C213.268 184.524 213.568 184.024 213.868 183.424C214.468 182.424 214.668 181.324 214.668 180.224V178.024L204.068 177.724Z",
    fill: "#231C61"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M194.868 214.224L191.668 215.424L189.668 215.524C188.768 215.524 187.968 216.224 187.768 217.024L187.668 217.424L198.268 219.124L198.668 214.824L194.868 214.224Z",
    fill: "#14103D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M198.368 219.124L187.668 217.424L187.868 216.524L198.468 218.224L198.368 219.124Z",
    fill: "#14103D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M190.068 143.424L186.068 149.724L187.968 151.124L192.168 144.424L190.068 143.424Z",
    fill: "#334FBE"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M184.868 132.924C184.868 132.924 186.768 140.724 196.168 143.824C196.468 143.924 196.668 144.124 196.668 144.424C196.768 145.324 196.768 147.324 194.668 147.824C194.468 147.924 194.268 147.824 194.068 147.724C192.668 146.824 185.468 142.624 178.568 143.824L184.868 132.924Z",
    fill: "#4265D1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M184.868 132.924C184.868 132.924 183.168 140.724 178.668 143.924C178.668 143.924 179.268 137.024 184.868 132.924Z",
    fill: "#334FBE"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M184.768 149.324C184.468 150.724 185.668 152.524 187.068 152.824C188.468 153.124 189.868 152.224 190.168 150.724C190.468 149.324 189.268 147.524 187.868 147.224C186.468 146.924 185.068 147.824 184.768 149.324Z",
    fill: "#EB8175"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M192.368 153.524L189.568 150.524L187.668 152.824L192.368 156.224",
    fill: "#EB8175"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M191.868 150.825L188.868 155.225L196.968 162.625C197.468 162.725 197.968 162.825 198.468 162.725L209.168 161.325C210.868 161.225 212.168 159.825 212.068 158.125C211.968 156.425 212.268 154.025 210.668 154.125L198.268 156.725L191.868 150.825Z",
    fill: "#C8C6F2"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M215.968 160.924C216.268 158.624 215.168 156.224 213.168 155.024C212.268 154.424 211.368 154.024 210.768 154.224C208.668 154.624 206.468 155.524 205.468 158.424C203.868 163.324 203.368 177.824 203.368 177.824L214.868 178.224L215.968 160.924Z",
    fill: "#D8D7FD"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M211.668 161.225L215.168 173.925L215.868 163.225L211.668 161.225Z",
    fill: "#C8C6F2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M225.769 186.324C226.869 185.324 226.969 183.224 225.969 182.124C224.969 181.024 223.269 180.924 222.169 181.924C221.069 182.924 220.969 185.024 221.969 186.124C222.969 187.224 224.669 187.324 225.769 186.324Z",
    fill: "#EB8175"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M220.568 177.224L222.668 182.424L225.468 181.724L223.668 176.224",
    fill: "#EB8175"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M220.668 181.224L226.368 179.924L222.469 166.624C222.369 166.124 222.068 165.624 221.768 165.224L214.568 156.324C213.568 154.924 211.968 155.224 210.568 156.124C209.168 157.124 208.868 159.024 209.768 160.424L216.668 168.724L220.668 181.224Z",
    fill: "#D8D7FD"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M208.068 152.424L208.268 154.424C208.368 155.124 208.868 155.724 209.568 156.024C210.868 156.424 212.168 155.324 211.968 154.024L211.468 150.924L208.068 152.424Z",
    fill: "#EB8175"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M208.268 154.224C208.268 154.224 211.768 154.124 212.068 151.024C212.368 147.924 208.568 149.824 208.568 149.824L208.168 152.824L208.268 154.224Z",
    fill: "#E16C5F"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M205.268 144.025C203.368 146.325 203.668 149.825 206.068 151.725C208.368 153.625 211.868 153.325 213.768 150.925C215.668 148.625 215.368 145.125 212.968 143.225C210.668 141.325 207.168 141.725 205.268 144.025Z",
    fill: "#EB8175"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M211.168 149.024C211.168 149.024 209.268 153.024 212.368 153.924C215.468 154.824 215.768 146.324 215.768 146.324L212.068 140.124L204.068 140.024L203.568 145.124C203.568 145.124 204.568 146.024 211.368 146.624L211.168 149.024Z",
    fill: "#231C61"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M208.969 144.924L210.569 149.224L213.269 147.424L208.969 144.924Z",
    fill: "#231C61"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M210.669 147.824C210.169 148.524 210.269 149.424 210.869 150.024C211.569 150.524 212.469 150.424 213.069 149.824C213.569 149.124 213.469 148.224 212.869 147.624C212.169 147.124 211.169 147.224 210.669 147.824Z",
    fill: "#EB8175"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M203.868 145.625C203.868 145.625 203.568 141.125 206.868 139.125C209.568 137.425 213.268 138.325 214.668 141.125C215.368 142.425 215.768 144.325 215.268 146.825L203.868 145.625Z",
    fill: "#F5D100"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.345 142.164C205.811 142.075 205.196 142.435 205.109 143.044L205.108 143.051L204.607 145.651L204.329 145.598L204.828 143.001C204.943 142.214 205.725 141.774 206.39 141.884C207.176 141.997 207.61 142.673 207.61 143.424V143.432L207.309 146.14L207.027 146.109L207.327 143.417C207.324 142.772 206.959 142.252 206.348 142.165L206.345 142.164Z",
    fill: "#F1AB00"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.305 145.462C202.34 145.151 202.621 144.927 202.932 144.962L215.432 146.362C215.743 146.396 215.967 146.677 215.932 146.988C215.897 147.299 215.616 147.523 215.305 147.488L202.805 146.088C202.494 146.053 202.27 145.773 202.305 145.462Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.836 191.084L290.736 178.284L292.602 180.165L279.702 192.964L277.836 191.084Z",
    fill: "#56B7F4"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.839 177.381L290.739 164.681L292.597 166.568L279.697 179.268L277.839 177.381Z",
    fill: "#56B7F4"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.839 163.781L290.739 151.081L292.597 152.968L279.697 165.668L277.839 163.781Z",
    fill: "#56B7F4"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.836 150.184L290.736 137.384L292.602 139.265L279.702 152.065L277.836 150.184Z",
    fill: "#56B7F4"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.836 136.584L290.736 123.784L292.602 125.665L279.702 138.464L277.836 136.584Z",
    fill: "#56B7F4"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.839 122.881L290.739 110.181L292.597 112.068L279.697 124.768L277.839 122.881Z",
    fill: "#56B7F4"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.839 109.281L290.739 96.5806L292.597 98.4682L279.697 111.168L277.839 109.281Z",
    fill: "#56B7F4"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.836 95.6843L290.736 82.8843L292.602 84.7646L279.702 97.5646L277.836 95.6843Z",
    fill: "#56B7F4"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.836 82.0842L290.736 69.2842L292.602 71.1645L279.702 83.9645L277.836 82.0842Z",
    fill: "#56B7F4"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.839 68.3807L290.739 55.6807L292.597 57.5683L279.697 70.2683L277.839 68.3807Z",
    fill: "#56B7F4"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.839 54.7806L290.739 42.0806L292.597 43.9682L279.697 56.6682L277.839 54.7806Z",
    fill: "#56B7F4"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.669 179.649H278.769V177H291.669V179.649Z",
    fill: "#56B7F4"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.669 166.049H278.769V163.4H291.669V166.049Z",
    fill: "#56B7F4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.669 152.449H278.769V149.8H291.669V152.449Z",
    fill: "#56B7F4"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.669 138.849H278.769V136.2H291.669V138.849Z",
    fill: "#56B7F4"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.669 125.149H278.769V122.5H291.669V125.149Z",
    fill: "#56B7F4"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.669 111.549H278.769V108.9H291.669V111.549Z",
    fill: "#56B7F4"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.669 97.9487H278.769V95.2998H291.669V97.9487Z",
    fill: "#56B7F4"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.669 84.3486H278.769V81.6997H291.669V84.3486Z",
    fill: "#56B7F4"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.669 70.6489H278.769V68H291.669V70.6489Z",
    fill: "#56B7F4"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.669 57.0488H278.769V54.3999H291.669V57.0488Z",
    fill: "#56B7F4"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.093 45.1245V195.725H277.444V45.1245H280.093Z",
    fill: "#5571E9"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.993 45.1245V195.725H290.344V45.1245H292.993Z",
    fill: "#5571E9"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M297.868 192.024H272.068V218.824H297.868V192.024Z",
    fill: "#231C61"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M291.668 45.1245H278.168C275.768 45.1245 273.868 43.2245 273.868 40.8245V23.9245C273.868 21.5245 275.768 19.6245 278.168 19.6245H291.668C294.068 19.6245 295.968 21.5245 295.968 23.9245V40.8245C295.968 43.2245 294.068 45.1245 291.668 45.1245Z",
    fill: "#56B7F4"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M284.668 37.7247H275.968V25.8247H284.668C286.468 25.8247 287.968 27.3247 287.968 29.1247V34.5247C287.868 36.3247 286.468 37.7247 284.668 37.7247Z",
    fill: "#2F4DAB"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.746 76.9776L192.346 46.8776L194.39 46.1714L204.79 76.2714L202.746 76.9776Z",
    fill: "#231C61"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.198 69.5818L185.298 42.3818L187.037 43.667L166.937 70.867L165.198 69.5818Z",
    fill: "#231C61"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M192.268 56.3245L213.068 83.6245C215.368 86.6245 214.768 90.9245 211.768 93.2245L184.468 114.024C181.468 116.324 177.168 115.724 174.868 112.724L154.068 85.5245C151.768 82.5245 152.368 78.2245 155.368 75.9245L182.668 55.1245C185.668 52.7245 189.968 53.3245 192.268 56.3245Z",
    fill: "#F5D100"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.224 61.8613C188.504 59.5977 185.365 59.1682 183.224 60.9522L183.215 60.9594L160.902 78.0699C158.755 79.6801 158.294 82.8269 160.01 85.0865C160.011 85.0868 160.011 85.0871 160.011 85.0874L177.113 107.39C178.723 109.537 181.87 109.998 184.13 108.282C184.13 108.282 184.13 108.281 184.131 108.281L206.433 91.1788C208.58 89.5687 209.041 86.422 207.325 84.1624C207.325 84.1621 207.325 84.1617 207.324 84.1613L190.226 61.8632L190.224 61.8613ZM191.11 61.1861C189.032 58.4539 185.179 57.8821 182.52 60.0891L160.231 77.1806C157.58 79.1708 157.042 83.0218 159.124 85.7613L159.126 85.7632L176.222 108.058C176.223 108.059 176.223 108.06 176.224 108.061C178.214 110.712 182.065 111.25 184.805 109.168L184.806 109.166L207.102 92.0699C207.103 92.0692 207.104 92.0685 207.104 92.0679C209.755 90.0777 210.293 86.2268 208.211 83.4874L191.111 61.1874C191.111 61.187 191.11 61.1865 191.11 61.1861Z",
    fill: "#231C61"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M185.368 94.7243C184.868 98.7243 178.668 97.9243 179.268 93.9243C179.768 89.8243 185.868 90.6243 185.368 94.7243ZM187.968 72.1243L185.568 89.1243L180.368 88.4243C181.168 82.7243 181.768 77.1243 182.568 71.4243L187.968 72.1243Z",
    fill: "#231C61"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M190.468 49.0242C195.218 49.0242 199.068 45.1739 199.068 40.4242C199.068 35.6746 195.218 31.8242 190.468 31.8242C185.719 31.8242 181.868 35.6746 181.868 40.4242C181.868 45.1739 185.719 49.0242 190.468 49.0242Z",
    fill: "#231C61"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M196.568 40.4242C196.568 43.8242 193.868 46.5242 190.468 46.5242C187.068 46.5242 184.368 43.8242 184.368 40.4242C184.368 37.0242 187.068 34.3242 190.468 34.3242C193.868 34.3242 196.568 37.0242 196.568 40.4242Z",
    fill: "#373482"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.044 19.6242V1.32422H225.693V19.6242H223.044Z",
    fill: "#56B7F4"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.644 19.6242V1.32422H209.292V19.6242H206.644Z",
    fill: "#56B7F4"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.443 19.6242V1.32422H242.092V19.6242H239.443Z",
    fill: "#56B7F4"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.644 19.6242V1.32422H260.292V19.6242H257.644Z",
    fill: "#56B7F4"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.644 19.6242V1.32422H277.292V19.6242H274.644Z",
    fill: "#56B7F4"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.243 19.6242V1.32422H294.892V19.6242H292.243Z",
    fill: "#56B7F4"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.544 19.6242V1.32422H312.193V19.6242H309.544Z",
    fill: "#56B7F4"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.33 2.23427L208.03 20.5343L206.105 18.7145L223.405 0.414551L225.33 2.23427Z",
    fill: "#56B7F4"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.63 2.23427L225.33 20.5343L223.405 18.7145L240.705 0.414551L242.63 2.23427Z",
    fill: "#56B7F4"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.93 2.23428L242.63 20.5343L240.705 18.7145L258.005 0.414551L259.93 2.23428Z",
    fill: "#56B7F4"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.231 2.23427L259.931 20.5343L258.006 18.7145L275.306 0.414551L277.231 2.23427Z",
    fill: "#56B7F4"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.531 2.23427L277.231 20.5343L275.306 18.7145L292.606 0.414551L294.531 2.23427Z",
    fill: "#56B7F4"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.83 2.23427L294.53 20.5343L292.605 18.7145L309.905 0.414551L311.83 2.23427Z",
    fill: "#56B7F4"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.033 0.498453C204.284 0.183454 204.665 0 205.068 0H312.468C312.811 0 313.14 0.132805 313.387 0.370515L332.387 18.6705C332.776 19.0453 332.898 19.6188 332.696 20.1198C332.494 20.6208 332.008 20.9489 331.468 20.9489H190.468C189.959 20.9489 189.495 20.6574 189.275 20.199C189.054 19.7405 189.115 19.1962 189.433 18.7984L204.033 0.498453ZM205.706 2.6489L193.219 18.3H328.184L311.934 2.6489H205.706Z",
    fill: "#5571E9"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.468 18.2998C191.199 18.2998 191.792 18.8928 191.792 19.6243V40.4243C191.792 41.1557 191.199 41.7487 190.468 41.7487C189.737 41.7487 189.144 41.1557 189.144 40.4243V19.6243C189.144 18.8928 189.737 18.2998 190.468 18.2998Z",
    fill: "#5571E9"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M115.868 216.224L125.768 190.724C126.268 189.524 127.968 189.524 128.468 190.724L138.368 216.224H115.868Z",
    fill: "#F5D100"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M135.668 196.224H118.168V201.624H135.668V196.224Z",
    fill: "#FAFAFA"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M137.069 206.524H117.269V211.924H137.069V206.524Z",
    fill: "#FAFAFA"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M140.168 216.224H114.068V218.424H140.168V216.224Z",
    fill: "#E8C400"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M259.269 216.324L269.169 190.824C269.669 189.624 271.369 189.624 271.869 190.824L281.769 216.324H259.269Z",
    fill: "#F5D100"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M279.068 196.324H261.568V201.724H279.068V196.324Z",
    fill: "#FAFAFA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M280.368 206.524H260.568V211.924H280.368V206.524Z",
    fill: "#FAFAFA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M283.569 216.324H257.469V218.524H283.569V216.324Z",
    fill: "#E8C400"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 218.925C0 218.611 0.254437 218.356 0.5683 218.356H344.468C344.782 218.356 345.037 218.611 345.037 218.925C345.037 219.239 344.782 219.493 344.468 219.493H0.5683C0.254437 219.493 0 219.239 0 218.925Z",
    fill: "#56B7F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.5a3135f381b00b53044eff200e725391.svg";
export { ForwardRef as ReactComponent };